/* eslint-disable jsx-a11y/anchor-is-valid */
import {useLocation, useNavigate } from "react-router-dom";
// import CustomerTable from "./CustomerTable";


import { useCallback, useEffect } from "react";

import underscore from "underscore";
import CsvDownload from 'react-json-to-csv';
import RestartAlt from '@mui/icons-material/RestartAlt';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import NotificationTable from "./NotificationTable";
import {notificationService} from "../../services/notification.service";
import { GetRecoilNotify, SetRecoilNotify} from "../../store/notificationMainAtom";
import GeneralCustomTable from "../../helpers/GeneralCustomTable";
import Tooltip from "@mui/material/Tooltip";



const columns = [
  {
    title: 'Ref',
    key: 'ref_no',
    dataIndex: 'ref_no',
  className: "text-primary",
  sorter: (a, b) => (a?.ref_no ?? '') - (b?.ref_no ?? '')
  },

  {
    title: 'date',
    dataIndex: 'notification_date',
  // className: "text-primary font-bold",
  sorter: (a, b) => (a?.notification_date ?? '').localeCompare(b?.notification_date ?? '')
  },
    
  {
    title: "Subject",
    dataIndex: "notification_subject",
    sorter: (a, b) => (a?.notification_subject ?? '').localeCompare(b?.notification_subject ?? '')
  },

    
  {
    title: "Message",
    dataIndex: "notification_message",
    sorter: (a, b) => (a?.notification_message ?? '').localeCompare(b?.notification_message ?? '')
  },

    
  {
    title: "Type",
    dataIndex: "notification_type_name",
    sorter: (a, b) => (a?.notification_type_name ?? '').localeCompare(b?.notification_type_name ?? '')
  },

    
  {
    title: "client(s)",
    dataIndex: "no_of_client",
    sorter: (a, b) => (a?.no_of_client ?? '').localeCompare(b?.no_of_client ?? '')
  },

    
  {
    title: "Sent By",
    dataIndex: "notification_send_by_name",
    sorter: (a, b) => (a?.notification_send_by_name ?? '').localeCompare(b?.notification_send_by_name ?? '')
  },




];




function NotificationSendPage() {
  const { pathname } = useLocation();  
  const setNotifyList = SetRecoilNotify();
  const getNotifyList = GetRecoilNotify();
  const navigate = useNavigate();
  var url = pathname.split('/')
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];


  useEffect(()=> {
    
if(!getNotifyList.notification?.length){
  loadDataFromServer();

}
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);



    useEffect(() => {
      document.title ="Subscription"
      if (sessionStorage.getItem("reloadPage") === "true") {
        sessionStorage.removeItem("reloadPage");
        loadDataFromServer();
      }
    }, []);


  const loadDataFromServer = ()=> {
    notificationService.getNotifyList().then(res => {
      if(res.data?.notification_type?.length){
        setNotifyList({notification: res?.data?.notification || [],
           notification_template: res.data.notification_template || [],
           notification_type: res.data?.notification_type || [], 
           notification_filter: res?.data?.notification_filter || [] });
      }
    });
  }

  function sendNewNotification(){
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`)
  }


  function handleRowClick(data){
    const id = data['ref_no'];
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${id}`);
}


const paginationOptions = {
  pageSize: 10,
  showSizeChanger: true,
  total: getNotifyList.notification?.length,
};


  

  return (

      <>
        <Grid container className="z-auto" >
          <Grid item xs={12}>
            <section className="w-full justify-end ">
                  <Tooltip title="Reload">
                              <RestartAlt
                                className="cursor-pointer text-blue-600 hover:text-blue-800 transition-colors self-center"
                                onClick={() => loadDataFromServer()}
                                color="primary"
                                fontSize="large"
                              />
                            </Tooltip>
            <div className="flex  justify-end">
              <div className="flex ">
                <button
                  style={{ color: "#476ef8" }}
                  className="  rounded  text-md font-[Poppins] py-2 mt-1  px-3"
                >
                  Import
                </button>

                <button
                  style={{ color: "#476ef8" }}
                  className=" mx-2 rounded  text-md font-[Poppins] mt-1 py-[1.8vh]  px-3"
                >
                  Export
                </button>
              </div>

             
                <button
                  style={{ backgroundColor: "#476EF8" }}
                  onClick={()=> sendNewNotification()}
                  className="  rounded text-white text-sm font-[Poppins] mt-1 py-[1.8vh]  px-3"
                >
                  SEND NEW
                </button>
           
            </div>
            </section>
            
          </Grid>
        </Grid>
    

      {/* <section className="mt-5   w-full">
       <NotificationTable list={getNotifyList.notification} ></NotificationTable>
      </section> */}
            <section className="mt-5">
              <GeneralCustomTable
                    tableHeadList={columns} 
                    tableDataList={getNotifyList.notification}
                  allowCheckBox={false} // show checkBox for each row
                  setSelectedRows={()=> console.log("")}
                  paginationOptions={paginationOptions} 
                  rowKey={(record) => record.ref_no} // custom key
                  handleRowClick={handleRowClick} />
              </section>
    </>
   
  );
}

export default NotificationSendPage;
